import { IBuyer } from './buyer'
import { ISalesOfficer } from './salesOfficer'

export enum LedgerHead {
  Buyer = 'buyer',
  SalesOfficer = 'sales_officer',
}

export enum LedgerSubhead {
  Wallet = 'wallet',
}

export enum LedgerLogTag {
  Cash = 'cash',
  Transfer = 'transfer',
  Order = 'order',
  Signup = 'signup',
}

export interface ILedger {
  _id: string
  head: LedgerHead
  subhead: LedgerSubhead
  owner: string
  balance: number
}

export interface ILedgerTag {
  _id?: string
  parent_id: string
  parent_type: string
  tag: string
  value: string
  created?: number
}

export interface ILedgerTagsDict {
  [tag: string]: ILedgerTag
}

export interface ILedgerReport extends ILedger {
  oldest: number
  ledger_logs: any
}

interface IOwnerBuyer extends IBuyer {
  ledger_tags?: ILedgerTagsDict
}
interface IOwnerSalesOfficer extends ISalesOfficer {
  ledger_tags?: ILedgerTagsDict
}

export interface ILedgerReportBuyer extends ILedgerReport {
  owner_object: IOwnerBuyer
}

export interface ILedgerReportSalesOfficer extends ILedgerReport {
  owner_object: IOwnerSalesOfficer
}

export interface ILedgerLog {
  readonly _id: string
  readonly value: number
  readonly description: string
  readonly tag: LedgerLogTag
  readonly ledger: ILedger
  readonly created: number
}
